import React from "react";
import { Link } from "react-router-dom";
import { observer } from "mobx-react-lite";
import { CFormLabel, CFormSelect } from "@coreui/react";
import settingsStore from "../../../store/SettingsStore";

// Reads the loading flag from the store directly (rather than relying on
// every caller to thread it through) so the "no servers configured" message
// never flashes before the first getServers() call has actually resolved.
const ServerSelect = observer(function ServerSelect({
  servers = [],
  value,
  onChange,
  id = "serverSelect",
  label = "Выберите сервер",
  className = "mb-3",
  disabled = false,
}) {
  const loading = settingsStore.serversLoading;

  if (!loading && servers.length === 0) {
    return (
      <div className={className}>
        <CFormLabel htmlFor={id}>{label}</CFormLabel>
        <div className="small text-body-secondary border rounded p-2">
          Нет подключённых серверов iiko.{" "}
          <Link to="/settings">Добавить сервер в настройках →</Link>
        </div>
      </div>
    );
  }

  return (
    <div className={className}>
      <CFormLabel htmlFor={id}>{label}</CFormLabel>
      <CFormSelect
        id={id}
        aria-label="Select server"
        value={value}
        onChange={onChange}
        disabled={disabled || loading}
      >
        {loading && <option value="">Загрузка…</option>}
        {servers.map((item) => (
          <option key={item.id} value={item.id}>
            {item.name}
          </option>
        ))}
      </CFormSelect>
    </div>
  );
});

export default ServerSelect;
